export default __webpack_public_path__ + "static/media/Giuria (5).48f8603f.jpg";